export default __webpack_public_path__ + "static/media/mountainImage2.860d4b15.webp";